import Badge from "../../../components/badges/Badge";
import React, { useState } from "react";
import { useWebRTC } from "../../../contexts/WebRTCContext";
import { ActionButton } from "../../../components/buttons/ActionButton";
import { ArrowsPointingInIcon, ArrowsPointingOutIcon } from "@heroicons/react/20/solid";


export const CameraBlock = ({ cam, camNumber, isFullscreen, onToggleFullscreen }) => {
  const { registerVideoEl } = useWebRTC();

  const [viewMode, setViewMode] = useState('object-contain');

  const switchViewMode = () => {
    setViewMode((viewMode) => viewMode === 'object-contain' ? 'object-cover' : 'object-contain');
  };

  return (
    <div className="h-full w-full">
      <div className="relative h-full w-full overflow-hidden rounded-lg bg-perception-black-800 group">
        <video
          ref={(el) => registerVideoEl(cam.id, el)}
          playsInline
          autoPlay
          muted
          className={`absolute inset-0 h-full w-full ${viewMode} object-center`}
        />

        <div className="absolute top-4 left-4 flex gap-2 opacity-1 md:opacity-0 group-hover:opacity-100 transition no-drag">
          <div className="bg-perception-black-800 rounded-md">
            <Badge text="LIVE" type="green"/>
          </div>
          <div className="bg-perception-black-800 rounded-md">
            <Badge text={`Caméra ${camNumber} [${cam.id}]`} type="gray"/>
          </div>
        </div>

        <div className="absolute top-4 right-4 flex gap-2 opacity-1 md:opacity-0 group-hover:opacity-100 transition no-drag">
          <ActionButton color="secondary" Icon={isFullscreen ? ArrowsPointingInIcon : ArrowsPointingOutIcon} size="sm" onClick={() => onToggleFullscreen(cam.id)}/>
          <ActionButton color="secondary" text={viewMode === 'object-contain' ? 'Recadrer' : 'Adapter'} size="sm" onClick={switchViewMode}/>
        </div>
      </div>
    </div>
  );
};